import { Component, Vue } from 'vue-property-decorator'
import Btn from '~/components/element/Btn'
import s from '~/utils/s'
import ReviewsSvg from '~/assets/svg/order-rating.svg?inline'

@Component
export default class OrderDetail extends Vue {
  showPopup (event: MouseEvent) {
    event.stopPropagation()

    s(this.$store).reviewsPage.showPopup()
  }

  isShowReviewBtn (): boolean {
    const { canReview, canUserReview } = s(this.$store).productPage
    const { isAuth } = s(this.$store).auth

    return canReview && (!isAuth || (isAuth && canUserReview))
  }

  renderOpenReviewPopupBtn () {
    return (
      <Btn {...{
        props: {
          label: 'Оставить отзыв',
          type: 'button'
        },
        nativeOn: {
          click: this.showPopup
        }
      }} />
    )
  }

  renderTextNoReviews () {
    const { canReview, canUserReview } = s(this.$store).productPage
    const { isAuth } = s(this.$store).auth

    if ((isAuth && canReview) && !canUserReview) {
      return (
        <div class="no-reviews__text">
          <div class="no-reviews__title">
            Мы не нашли данный товар среди ваших покупок.
          </div>

          <div>Вы можете оставлять отзывы только к товарам,</div>
          <div>которые приобретали</div>
        </div>
      )
    } else {
      return (
        <div class="no-reviews__text">
          <div class="no-reviews__title">
            Отзывов еще нет. Станьте первым
          </div>

          <div>Напишите свои впечатления о товаре</div>
          <div>Это поможет другим покупателям</div>
        </div>
      )
    }
  }

  render () {
    return (
      <div>
        <div class="no-reviews">
          {this.renderTextNoReviews()}

          <div class="no-reviews__image">
            <ReviewsSvg />
          </div>
        </div>

        <div class="no-reviews__button no-reviews__button_desktop">
          { this.isShowReviewBtn() && this.renderOpenReviewPopupBtn() }
        </div>
      </div>
    )
  }
}
